/* eslint-disable max-lines-per-function */

import { FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, FormLabel, InteractiveTable } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';

import { useScopeOfProvidedServicesColumns } from './ScopeOfProvidedServicesInteractiveTable.hooks';
import {
   ScopeOfProvidedServicesFormBeanPart,
   ScopeOfProvidedServicesInteractiveTableBean,
} from './ScopeOfProvidedServicesInteractiveTable.types';
import { createScopeOfProvidedServicesTableBean } from './ScopeOfProvidedServicesInteractiveTable.utils';

export type ScopeOfProvidedServicesInteractiveTableProps = Pick<
   FormContextValues<ScopeOfProvidedServicesFormBeanPart>,
   'register'
> &
   ClassNameProp;

export const ScopeOfProvidedServicesInteractiveTable = (
   props: ScopeOfProvidedServicesInteractiveTableProps
): JSX.Element => {
   const columns = useScopeOfProvidedServicesColumns();

   return (
      <InteractiveTable<ScopeOfProvidedServicesInteractiveTableBean, ScopeOfProvidedServicesFormBeanPart>
         testId={'scopeOfProvidedServices'}
         name={'scopeOfProvidedServices'}
         register={props.register}
         columns={columns}
         className={props.className}
         header={
            <FormLabel
               testId={'scopeOfProvidedServices'}
               label={healthcareOrganizationTranslationKeys.scopeOfProvidedServices}
            />
         }
      >
         <InteractiveTable.AddRowButton
            label={healthcareOrganizationTranslationKeys.addScopeOfProvidedServices}
            onAddRow={createScopeOfProvidedServicesTableBean}
         />
      </InteractiveTable>
   );
};
